import { connect } from 'react-redux';

import { selectors } from 'dux/createInstance';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import UnstyledPlanSelector from './PlanSelector';

function mapStateToProps(state) {
  return {
    availablePlans: selectors.availablePlansSelector(state),
    selectedService: selectors.selectedServiceSelector(state),
    availablePlansInfo: selectors.availablePlansInfoSelector(state),
  };
}

const mapDispatchToProps = {
  trackButtonClick: clickTrackerActionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnstyledPlanSelector);
